<template>
    <div class="growthFileShengya">
        <div class="rzqn xqqx">
            <div class="rzqnTitle">认知潜能指标评估详细结果</div>
            <table>
                <tbody>
                <tr style="line-height: 40px">
                    <th>职业类型</th>
                    <th width="35">10</th>
                    <th width="35">20</th>
                    <th width="35">30</th>
                    <th width="35">40</th>
                    <th width="35">50</th>
                    <th width="35">60</th>
                    <th width="35">70</th>
                    <th width="35">80</th>
                    <th width="35">90</th>
                    <th width="35">100</th>
                    <th>指数</th>
                    <th width="260">典型职业</th>
                </tr>
                <tr>
                    <td class='blue'>
                        传统型 <br/> （C）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:changgui&&changgui.score/100*350+'px'}">
                            <span :style="{left:changgui&&changgui.lnorm/100*350+'px',width:(changgui.rnorm-changgui.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{changgui&&changgui.score}}</td>
                    <td class="tdDetail"> 信息处理、行政办公、财务会计和经营分析等方面的职业领域；</td>
                </tr>

                <tr>
                    <td class='blue'>
                        实际型 <br/> （R）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:shiji&&shiji.score/100*350+'px'}">
                            <span :style="{left:shiji&&shiji.lnorm/100*350+'px',width:(shiji.rnorm-shiji.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{shiji&&shiji.score}}</td>
                    <td class="tdDetail"> 技术性职业岗位：计算机硬件、装备制造业领域；技能性职业领域：加工业、农业机械领域。</td>
                </tr>

                <tr>
                    <td class='blue'>
                        研究型 <br/> （I）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:diaoyan&&diaoyan.score/100*350+'px'}">
                            <span :style="{left:diaoyan&&diaoyan.lnorm/100*350+'px',width:(diaoyan.rnorm-diaoyan.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{diaoyan&&diaoyan.score}}</td>
                    <td class="tdDetail"> 科学研究领域、工程设计、教育、软件业、医疗、工程规划设计等职业类型。</td>
                </tr>

                <tr>
                    <td class='blue'>
                        艺术型 <br/> （A）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:yishu&&yishu.score/100*350+'px'}">
                            <span :style="{left:yishu&&yishu.lnorm/100*350+'px',width:(yishu.rnorm-yishu.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{yishu&&yishu.score}}</td>
                    <td class="tdDetail"> 艺术领域方面：艺术设计、演艺业、摄影；音乐领域方面：歌唱家、作曲家；文学方面：小说家、诗人、剧作家等。</td>
                </tr>

                <tr>
                    <td class='blue'>
                        社会型  <br/> （S）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:shehui&&shehui.score/100*350+'px'}">
                            <span :style="{left:shehui&&shehui.lnorm/100*350+'px',width:(shehui.rnorm-shehui.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{shehui&&shehui.score}}</td>
                    <td class="tdDetail"> 教育领域：教育培训；社会工作者：社会工作事业、社会公益人员、咨询。；</td>
                </tr>

                <tr>
                    <td class='blue'>
                        企业型 <br/> （E）
                    </td>
                    <td colSpan='10'>
                        <div  :style="{width:qiye&&qiye.score/100*350+'px'}">
                            <span :style="{left:qiye&&qiye.lnorm/100*350+'px',width:(qiye.rnorm-qiye.lnorm)/100*350 +'px'}"></span>
                        </div>
                    </td>
                    <td>{{qiye&&qiye.score}}</td>
                    <td class="tdDetail"> 社会机构组织管理者、企业经营、建设项目、市场营销与司法服务。</td>
                </tr>
                </tbody>
            </table>
            <div id="radarChartContainer">
            </div>
            <div class="rzqnTitle">
                兴趣倾向评估结果示意图
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "xqqx",
    props:['norm'],
    data(){
        return {
            // norm:{},
            // options:{},
            // changgui:'',
            // shiji:'',
            // diaoyan:'',
            // yishu:'',
            // shehui:'',
            // qiye:''
        }
    },
    computed: {
        changgui() {
            return this.norm.changgui||{};
        },
        shiji() {
            return this.norm.shiji||{};
        },
        diaoyan() {
            return this.norm.diaoyan||{};
        },
        yishu() {
            return this.norm.yishu||{};
        },
        shehui() {
            return this.norm.shehui||{};
        },
        qiye() {
            return this.norm.qiye||{};
        }
    },
    methods:{
        // getData(){
        //     this.$ajax.post(this.G_report + this.ports.consultant.student.report.xqqx,{
        //         report_id:this.reportId
        //     },{
        //         headers: {
        //             token: window.sessionStorage.getItem('zxsToken')
        //         }
        //     }).then(res=>{
        //         if(res.data.code==0){
        //             const{ norm,data }=res.data.result
        //             this.norm=norm
        //             const { changgui,shiji,diaoyan,yishu,shehui,qiye}=norm||{}
        //             this.changgui=changgui;
        //             this.shiji=shiji;
        //             this.diaoyan=diaoyan;
        //             this.yishu=yishu;
        //             this.shehui=shehui;
        //             this.qiye=qiye;
        //             let scores=[];
        //             scores.push(data.shehui);
        //             scores.push(data.qiye);
        //             scores.push(data.changgui);
        //             scores.push(data.shiji);
        //             scores.push(data.diaoyan);
        //             scores.push(data.yishu);
        //
        //             let tagNames = [{
        //                 name: 'S社会',
        //                 max: 100
        //             }, {
        //                 name: 'E企业',
        //                 max: 100
        //             }, {
        //                 name: 'C常规',
        //                 max: 100
        //             }, {
        //                 name: 'R实际',
        //                 max: 100
        //             }, {
        //                 name: 'I调研',
        //                 max: 100
        //             }, {
        //                 name: 'A艺术',
        //                 max: 100
        //             },];
        //             this.draw(scores,tagNames)
        //         }else{
        //         }
        //     })
        // },
        // draw(scores,tagNames){
        //     let myChart = this.$echarts.init(document.getElementById('radarChartContainer'));
        //     // 基于准备好的dom，初始化echarts实例
        //     let options={
        //         tooltip: {},
        //         legend: {
        //             data: ['兴趣倾向评估']
        //         },
        //         radar: {
        //             name: {
        //                 color: '#000',
        //                 fontSize: 15,
        //                 textStyle: {
        //                     color: '#FFFFFF',
        //                     backgroundColor: '#3D90F6',
        //                     borderRadius: 3,
        //                     padding: [5, 10]
        //                 }
        //             },
        //             indicator: tagNames,
        //             splitArea : {
        //                 show : true,
        //                 areaStyle : {
        //                     color: ['transparent', '#EEF8FE','transparent', '#EEF8FE', 'transparent',]
        //                     // 图表背景网格的颜色
        //                 }
        //             },
        //         },
        //
        //         calculable: true,
        //         series: [{
        //             type: 'radar',
        //             symbol:'circle',
        //             data: [{
        //                 value: scores,
        //                 name: '兴趣倾向评估结果'
        //             },],
        //             lineStyle:{
        //                 color:'#3D90F6'
        //             },
        //             symbolSize :8,
        //             color :"#3D90F6"
        //         }],
        //     }
        //     // 使用刚指定的配置项和数据显示图表。
        //     myChart.setOption(options);
        // }
    },
    mounted() {

        // this.getData()
    },
}
</script>

<style lang="less" scoped>
@import './com_report.less';
</style>